import React from 'react';
import styled from 'styled-components';
interface LogoIconProps {
  gradientId?: string;
}

export const LogoContainer = styled.div`
  height: 40px;
  align-items: center;
  display: flex;
  flex-shrink: 0;
  margin-left: 6px;
  margin-bottom: -0.5rem;
`;

const LogoIcon = ({ gradientId = 'clip0_2690_6709' }: LogoIconProps) => {
  return (
    <LogoContainer>
      <svg id={gradientId} width="102" height="24" viewBox="0 0 102 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.7945 6.24622C21.3842 3.3614 20.2321 1.66509 18.1111 0.850867C16.7342 0.273028 15.0976 0.104492 11.3749 0.104492C9.14263 0.104492 7.3184 0.207365 6.38882 0.343069C4.30492 0.715162 2.85382 1.59943 2.03553 2.95648C0.992486 4.6878 0.807007 5.977 0.807007 10.7617C0.807007 15.5464 0.844102 16.3606 1.10595 17.8533C1.51401 20.2282 2.63124 21.7231 4.52967 22.4695C5.71455 22.9313 6.75105 23.1217 8.77168 23.1874V20.9702C7.27476 20.9111 6.5743 20.7841 5.90658 20.5368C4.75225 20.1297 4.08234 19.1797 3.82267 17.6191C3.67429 16.7597 3.6001 14.7686 3.6001 11.6459C3.6001 8.93185 3.61246 7.41648 3.63719 7.09984C3.78558 5.19998 4.12162 4.18219 4.86572 3.4008C5.7211 2.51872 6.98672 2.31516 11.4906 2.31516C14.7659 2.31516 15.8439 2.41585 16.8498 2.79013C18.0041 3.19724 18.6741 4.14717 18.9337 5.70778C19.0821 6.56724 19.1563 8.54663 19.1563 11.6459V15.2771L19.1192 15.9228C19.1192 16.3978 18.9686 17.606 18.8028 18.4574L18.4166 19.2301C17.7619 20.5433 16.5203 20.9658 12.7126 21.0074V21.2328H10.2075V21.0052C10.2075 21.0052 10.1922 21.0052 10.1857 21.0052V23.2158C10.4584 23.2158 10.7421 23.218 11.0454 23.218C15.3616 23.218 16.4789 23.1173 18.1154 22.4717C19.2327 22.0645 20.2823 21.0905 20.6096 20.6396L21.5021 18.7048C21.8752 17.2448 21.9494 16.0914 21.9494 10.6282C21.9494 7.81119 21.9123 7.26838 21.801 6.25059L21.7945 6.24622Z"
          fill="#1784EC"
        />
        <path
          d="M11.3858 12.4558C12.6319 12.4558 13.6421 11.4426 13.6421 10.1926C13.6421 8.94271 12.6319 7.92944 11.3858 7.92944C10.1397 7.92944 9.12952 8.94271 9.12952 10.1926C9.12952 11.4426 10.1397 12.4558 11.3858 12.4558Z"
          fill="#FF6C0A"
        />
        <path
          d="M10.2031 14.0448L10.1704 23.1873C10.6287 23.1917 11.3858 21.4451 11.8965 21.7077C12.2827 21.9047 12.4071 21.7493 12.7104 21.7449V14.0448H10.2031Z"
          fill="#1784EC"
        />
        <path
          d="M35.1227 21.1562H31.8495L24.4784 3.91077H27.649L33.5254 18.5712L39.4803 3.91077H42.4436L35.1227 21.1562Z"
          fill="#FF6C0A"
        />
        <path
          d="M44.2461 3.91077H46.7468V6.52198H44.2461V3.91077ZM46.7468 8.56631V21.1584H44.2461V8.56631H46.7468Z"
          fill="#FF6C0A"
        />
        <path
          d="M60.5115 10.5559H54.8664C53.1404 10.5559 52.8807 10.6084 52.5731 10.893C52.2894 11.2038 52.1344 11.694 52.1344 12.3157C52.1344 13.583 52.5469 13.8412 54.609 13.8412H56.311C59.0954 13.8675 59.2241 13.8938 59.7914 14.2287C60.5901 14.7189 61.0549 15.8834 61.0549 17.3827C61.0549 19.0374 60.4613 20.2785 59.4314 20.795C58.8379 21.1058 58.2967 21.1562 56.3132 21.1562H49.6883V19.1644H55.7196C56.9831 19.1644 57.5744 19.1118 57.8581 18.9827C58.2705 18.8273 58.4778 18.3633 58.4778 17.5862C58.4778 16.7589 58.2465 16.3189 57.7054 16.1635C57.4479 16.111 57.0616 16.0869 55.8746 16.0869H54.8686C52.189 16.0869 51.5955 15.9841 50.8732 15.415C50.0484 14.743 49.5596 13.5545 49.5596 12.2872C49.5596 10.8404 50.1771 9.62346 51.2092 9.08064C51.8791 8.71949 52.7564 8.56409 54.1987 8.56409H60.5137V10.5559H60.5115Z"
          fill="#FF6C0A"
        />
        <path
          d="M63.8872 3.91077H66.3879V6.52198H63.8872V3.91077ZM66.3879 8.56631V21.1584H63.8872V8.56631H66.3879Z"
          fill="#FF6C0A"
        />
        <path
          d="M71.0009 3.91077H73.5016V8.56412H77.137V10.5559H73.5016V17.1748C73.5016 18.9324 73.7329 19.1666 75.6662 19.1666H77.1348V21.1584H74.7367C71.9021 21.2109 70.9987 20.3047 70.9987 17.3827V10.5581H68.6006V8.56631H70.9987V3.91296L71.0009 3.91077Z"
          fill="#FF6C0A"
        />
        <path d="M79.714 3.91077H82.4722V21.1562H79.714V3.91077Z" fill="#1784EC" />
        <path
          d="M101.493 21.1562H96.5445C96.3634 21.1562 95.772 21.1562 94.921 21.1824H93.7361C90.5393 21.1824 88.942 20.795 87.4735 19.6306C85.5925 18.1313 84.5342 15.6492 84.5342 12.7009C84.5342 7.03851 87.7048 3.65247 92.9876 3.65247C98.2705 3.65247 101.055 6.75397 101.055 12.1581C101.055 15.2596 100.333 17.096 98.3993 18.9586H101.491V21.1562H101.493ZM88.7347 7.50472C87.9361 8.48749 87.4451 10.3742 87.4451 12.4951C87.4451 14.4344 87.8313 16.0103 88.5798 17.1222C89.3523 18.3107 91.0019 19.009 93.04 19.009C95.0781 19.009 96.2608 18.3633 97.1118 16.9406C97.7817 15.8287 98.1418 14.3556 98.1418 12.7009C98.1418 8.09788 96.4157 5.85 92.8829 5.85C91.1045 5.85 89.6097 6.44535 88.7325 7.50472H88.7347Z"
          fill="#1784EC"
        />
      </svg>
    </LogoContainer>
  );
};

export default LogoIcon;
